
import { defineComponent } from 'vue';
import HeadingContainer from '@/components/UI/HeadingContainer.vue';
import { Routes } from '@/types/router';

export default defineComponent({
    name: 'ConfirmView',
    components: { HeadingContainer },
    setup () {
        const route = { name: Routes.GetUpdates };
        return { route };
    }
});
